import * as React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'react-bootstrap';
import AddressForm from './AddressForm/AddressForm';
import { IShippingAddress } from '../../ShippingAddress';

export default function AddressModal(props: {
  onHide: any;
  show: boolean;
  shippingAddress?: IShippingAddress;
  refetch?: any;
  is_vts: boolean;
}) {
  return (
    <Modal show={props.show} centered size={'lg'} onHide={props.onHide}>
      <ModalHeader style={{ borderBottom: 'none' }} closeButton>
        <h2>Edit your shipping address</h2>
      </ModalHeader>
      <ModalBody>
        <AddressForm
          onHide={props.onHide}
          shippingAddress={props.shippingAddress}
          refetch={props?.refetch}
          is_vts={props.is_vts}
        />
      </ModalBody>
      <ModalFooter style={{ borderTop: 'none' }}>
        <Button form={'form_shipping_address'} type={'submit'}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
